<template>
<nav class="navbar navbar-expand-lg custom-navbar">
  <div class="container-fluid">

    <!-- Logo -->
    <a
      href="https://projects.dotlinkertech.com/strata-landing/"
      class="navbar-brand"
    >
      <img
        src="assets/imagesLanding/new-logo.png"
        alt="DIY Strata Management"
        class="logo-img"
      />
    </a>

    <!-- Mobile toggle -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Menu -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto align-items-lg-center">

        <li class="nav-item">
          <a class="nav-link"
             href="https://projects.dotlinkertech.com/strata-landing/features/">
            Features
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link"
             href="https://strata.dotlinkertech.com/pricing">
            Pricing
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link"
             href="https://projects.dotlinkertech.com/strata-landing/how-to-switch/">
            How to Switch
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link"
             href="https://projects.dotlinkertech.com/strata-landing/resources/">
            Resources
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link"
             href="https://projects.dotlinkertech.com/strata-landing/faq/">
            FAQ
          </a>
        </li>

        <!-- Login / Logout -->
        <li class="nav-item ms-lg-3">

          <!-- Login -->
          <router-link
            v-if="!isLoggedIn"
            class="btn get-started-btn"
            to="/login"
          >
            Member Login
          </router-link>

          <!-- Logout -->
          <button
            v-else
            class="btn get-started-btn d-flex align-items-center gap-2"
            @click="logout"
            :disabled="loader"
          >
            <span v-if="!loader">Logout</span>
            <loader v-else />
          </button>

        </li>

      </ul>
    </div>
  </div>
</nav>
</template>


<script>
import loader from '../loader.vue';

export default {
  name: "HeaderPage",
  components: { loader },

  data() {
    return { loader: false };
  },

  computed: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    }
  },

  methods: {
    logout() {
      this.loader = true;
      this.$store.dispatch("logout", {
        userToken: localStorage.getItem("token"),
        name: "admin",
      })
      .finally(() => {
        this.loader = false;
      });
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../public/assets/cssLanding/bootstrap.min.css"></style>
<style scoped src="../../../public/assets/fontsLanding/iconfonts.css"></style>
<style scoped src="../../../public/assets/cssLanding/plugins.css"></style>
<style scoped src="../../../public/assets/cssLanding/style.css"></style>
<style scoped src="../../../public/assets/cssLanding/responsive.css"></style>
<style scoped src="../../../public/assets/cssLanding/color.css"></style>
<style scoped>
/* Navbar wrapper */
.navbar{
  padding: 10px 130px !important;
}

.custom-navbar {
  background: #ffffff;
  padding: 25px 80px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

/* Logo */
.logo-img {
  width: 87%;
  max-width: 200px;
  height: auto;
}

/* Menu links */
.nav-link {
  color: #333333 !important;
  font-size: 16px;
  font-weight: 400;
  padding: 0 10px !important;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #605BE5 !important;
  border-bottom: 2px solid #605BE5;
}

/* Get Started Button */
.get-started-btn {
  background-color: #2f8f57;
  color: #ffffff !important;
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.get-started-btn:hover {
  background-color: #257446;
}

/* Mobile */
@media (max-width: 768px) {
  .custom-navbar {
    padding: 20px;
  }

  .get-started-btn {
    margin-top: 15px;
    width: 100%;
    text-align: center;
  }
}
</style>

